module.exports = __webpack_public_path__ + "static/media/greencat.634059cf.png";